import { useNavigate } from "react-router-dom";
import { getUser, clearSession } from "../../../api/session";

function Topbar({ onMenuClick = () => {} }) {
    const navigate = useNavigate();

    const user = getUser();

    const handleLogout = () => {
        clearSession();
        navigate("/login", { replace: true });
    };

    return (
        <header className="sticky top-0 z-10 flex items-center justify-between border-b border-sand bg-white px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3">
                <button
                    onClick={onMenuClick}
                    aria-label="Open menu"
                    className="text-2xl text-maroon lg:hidden"
                >
                    ☰
                </button>
                <div>
                    <p className="eyebrow">Fashion Freude</p>
                    <h4 className="font-display text-xl text-ink sm:text-2xl">Admin Dashboard</h4>
                </div>
            </div>

            <div className="flex items-center gap-3">
                <span className="hidden text-sm text-muted sm:block">
                    {user?.email || "Signed in"}
                </span>

                <span className="chip">
                    <span className="mr-1">👤</span> {user?.name || "Admin"}
                </span>

                <button
                    onClick={handleLogout}
                    className="rounded-full border border-sand px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-maroon transition hover:border-gold hover:text-gold"
                >
                    Logout
                </button>
            </div>
        </header>
    );
}

export default Topbar;
